// extracted by mini-css-extract-plugin
export default {"colors":"styles_colors__SVM0e","color":"styles_color__Q1ilU"};